import { api, handleError } from "./baseApi";

export async function createBank(
  operator_id,
  bank_name,
  account_number,
  ifsc_code,
  user_type
) {
  try {
    const { data } = await api.post(`/bank`, {
      operator_id,
      user_type,
      bank_name,
      account_number,
      ifsc_code,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function getBank(user_id, user_type) {
  try {
    const { data } = await api.get(
      `/bank/?user_type=${user_type}&user_id=${user_id}`
    );
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function updateBank(
  bank_id,
  bank_name,
  account_number,
  ifsc_code
) {
  try {
    const { data } = await api.put(`/bank/${bank_id}`, {
      bank_name,
      account_number,
      ifsc_code,
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}
